var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { MdSecurity, MdHelpOutline, MdExitToApp } from 'react-icons/md';
import { Box, IconDropdown, Spinner, Text } from "./..";
import { useToggle } from "../../hooks";
import { UserDropdownAction } from './UserDropdownAction';
var UncontrolledUserDropdown = function (_a) {
    var isOpen = _a.isOpen, onToggle = _a.onToggle, user = _a.user, changePassword = _a.changePassword, CustomActions = _a.customActions, _b = _a.supportUrl, supportUrl = _b === void 0 ? 'https://support.lucidhq.com' : _b, _c = _a.logoutUrl, logoutUrl = _c === void 0 ? '/logout' : _c, _d = _a.userDropdownLss, userDropdownLss = _d === void 0 ? {} : _d;
    var _e = __read(useState(false), 2), isLoadingPasswordChange = _e[0], setIsLoadingPasswordChange = _e[1];
    var username = (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.nickname) || (user === null || user === void 0 ? void 0 : user.email);
    var nameArr = typeof username === 'string' ? username.split(' ') : [];
    var _f = __read(nameArr.length > 1 ? nameArr : [username, ''], 2), firstName = _f[0], lastName = _f[1];
    var InitialsIcon = (React.createElement(Text, { lss: { textScale: 'control', fontWeight: 'light' } },
        firstName && firstName[0],
        lastName && lastName[0]));
    var onChangePassword = function () {
        setIsLoadingPasswordChange(true);
        if (typeof changePassword !== 'function')
            return;
        changePassword().then(function () { return setIsLoadingPasswordChange(false); });
    };
    return (React.createElement(IconDropdown, { id: "user-dropdown", isOpen: isOpen, icon: user.picture ? false : InitialsIcon, showArrow: true, onToggle: onToggle, ariaLabel: "User Menu", arrowColor: "secondary", buttonProps: {
            lss: __assign({ backgroundColor: '#12754D', backgroundImage: "url(\"" + user.picture + "\")", backgroundPosition: 'center', backgroundSize: 'cover', color: 'white', ':not([disabled]):hover': {
                    backgroundColor: '#126A46',
                    color: 'white',
                    textDecoration: 'none'
                }, ':focus': {
                    outline: 'none',
                    backgroundColor: '#126A46',
                    boxShadow: '0px 0px 5px #1166DD'
                }, ':active': {
                    backgroundColor: '#126A46'
                } }, userDropdownLss)
        } },
        React.createElement(React.Fragment, null,
            React.createElement(Box, { lss: {
                    bg: 'secondary500',
                    px: 'lg',
                    py: 'sm',
                    borderTopLeftRadius: 'inherit',
                    borderTopRightRadius: 'inherit'
                } },
                React.createElement(Text, { lss: { textScale: 'control', color: 'white' } }, "Hi " + firstName + "!")),
            CustomActions && React.createElement(CustomActions, { onToggle: onToggle }),
            React.createElement(UserDropdownAction, { icon: MdHelpOutline, text: "Help", to: supportUrl, opensLinkInNewTab: true, hasDividerAbove: !!CustomActions, onClick: onToggle }),
            changePassword && (React.createElement(UserDropdownAction, { icon: isLoadingPasswordChange ? Spinner : MdSecurity, text: "Change Password", onClick: function () {
                    onChangePassword();
                    onToggle && onToggle();
                } })),
            React.createElement(UserDropdownAction, { icon: MdExitToApp, text: "Sign Out", to: logoutUrl, onClick: onToggle }))));
};
var ControlledUserDropdown = function (_a) {
    var props = __rest(_a, []);
    var _b = __read(useToggle(), 2), isOpen = _b[0], toggle = _b[1];
    return (React.createElement(UncontrolledUserDropdown, __assign({ isOpen: isOpen, onToggle: toggle }, props)));
};
/**
 * This component can work both in an uncontrolled fashion by passing a boolean value to the isOpen and onToggle props
 * or it can be controlled when not passing these props.
 */
export var UserDropdown = function (_a) {
    var props = __rest(_a, []);
    return typeof props.isOpen === 'boolean' ? (React.createElement(UncontrolledUserDropdown, __assign({}, props))) : (React.createElement(ControlledUserDropdown, __assign({}, props)));
};
//# sourceMappingURL=UserDropdown.js.map